module.exports = __webpack_public_path__ + "img/12_9.4c12f91f.png";